import { useCallback, useEffect, useRef } from 'react';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Circle as CircleGeom, Point } from 'ol/geom';
import { Style, Stroke, Fill, Circle as CircleStyle } from 'ol/style';
import { Feature } from 'ol';
import { unByKey } from 'ol/Observable';

const pointerStyle = new Style({
    image: new CircleStyle({
        radius: 5,
        fill: new Fill({ color: '#ff9800' }),
        stroke: new Stroke({ color: '#ff9800', width: 2 }),
    }),
});

const circleStyle = new Style({
    stroke: new Stroke({ color: '#ff9800', width: 2 }),
    fill: new Fill({ color: 'rgba(255, 152, 0, 0.2)' }),
});

const useLifestyleRadiusSelection = ({
    mapRef,
    radius,
    isActive,
    onComplete,
    onDeactivate,
}) => {
    const layerRef = useRef(null);
    const clickListenerRef = useRef(null);
    const pointerListenerRef = useRef(null);
    const pointerFeatureRef = useRef(null);

    const ensureLayer = useCallback(() => {
        const map = mapRef.current;
        if (!map) return null;

        if (!layerRef.current) {
            const layer = new VectorLayer({
                source: new VectorSource(),
                zIndex: 1200,
                layerName: "ensureLayer"
            });
            map.addLayer(layer);
            layerRef.current = layer;
        }
        return layerRef.current;
    }, [mapRef]);

    useEffect(() => {
        const map = mapRef.current;
        if (!map || !isActive || !radius) return;

        const layer = ensureLayer();
        if (!layer) return;

        const source = layer.getSource();
        source.clear();

        const pointerFeature = new Feature(new Point([0, 0]));
        pointerFeature.setStyle(pointerStyle);
        source.addFeature(pointerFeature);
        pointerFeatureRef.current = pointerFeature;

        const handlePointerMove = (event) => {
            pointerFeature.getGeometry().setCoordinates(event.coordinate);
        };

        const handleClick = (event) => {
            // pointerFeature.setGeometry(new Point(event.coordinate));
            // source.clear();

            // const circle = new CircleGeom(event.coordinate, radius);
            // const circleFeature = new Feature(circle);
            // circleFeature.setStyle(circleStyle);
            // source.addFeature(circleFeature);

            onComplete?.({
                coordinate: event.coordinate,
                radius,
                // circle,
            });
        };

        pointerListenerRef.current = map.on('pointermove', handlePointerMove);
        clickListenerRef.current = map.on('click', handleClick);

        return () => {
            if (pointerListenerRef.current) {
                unByKey(pointerListenerRef.current);
                pointerListenerRef.current = null;
            }
            if (clickListenerRef.current) {
                unByKey(clickListenerRef.current);
                clickListenerRef.current = null;
            }
            source.clear();
            onDeactivate?.();
        };
    }, [ensureLayer, isActive, mapRef, onComplete, onDeactivate, radius]);

    return { layerRef };
};

export default useLifestyleRadiusSelection;
